import i18n from 'i18next';
import moment from 'moment';
import { Permission } from '../../features/user/Permission';
import { Buttons} from '../../components/control/Buttons'
import { ANNOUNCEMENT_STATUS, getAnnouncementStatus } from '../../features/announcement/AnnouncementApi';

const formatAnnouncementDate = value => {
	if (!value) return '';
	const date = moment.parseZone(value);
	return date.isValid() ? date.format('YYYY-MM-DD') : '';
};

const getStatusBgColor = announcement => {
	const colors = {
		4: '#52c41a',
		2: '#1677ff',
		3: '#fadb14',
		1: '#8c8c8c',
	};
	return colors[getAnnouncementStatus(announcement)] || colors.DRAFT;
};

export const getAnnouncementDataColumns = ( onEdit, onDelete, onView) => [
	{
		fixed: 'left',
		width: '8px',
		onCell: (record) => ({
			style: {
				backgroundColor: getStatusBgColor(record),
			},
		}),
	},
	{
		title: i18n.t('Announcement.Table.Title'),
		render: (e, r) => <div style={{textWrap:"balance"}}>{r.title}</div>,
		width: '35%'
	},
	{
		title: i18n.t('Announcement.Table.Status'),
		render: (e, r) => {
			const status = getAnnouncementStatus(r);
			return <div>{i18n.t(`Announcement.Status.${ANNOUNCEMENT_STATUS[status]}`)}</div>;
		},
		width: '15%'
	},
	{
		title: i18n.t('Announcement.Table.From'),
		render: (e, r) => <div>{formatAnnouncementDate(r.startAt)}</div>,
		width: '15%'
	},
	{
		title: i18n.t('Announcement.Table.To'),
		render: (e, r) => <div>{formatAnnouncementDate(r.endAt)}</div>,
		width: '15%'
	},
	{
		title: i18n.t('Announcement.Table.UpdatedBy'),
		render: (e, r) => <div>{`${r.lastUpdatedByUser?.firstName || ''} ${r.lastUpdatedByUser?.lastName || ''}`}</div>,
		responsive: ['md'],
		width: '15%'
	},
	{
		align:"center",
		render: (e, r) => {
			let actions = [];
			if (onView) {
				actions.push({
					name: i18n.t('Common.View'),
					onClick: () => {
						onView(r)
					},
					permission: [Permission.COMMON_EDIT],
				});
			}

			if (onEdit) {
				actions.push({
					name: i18n.t('Common.Edit'),
					onClick: () => {
						onEdit(r)
					},
					permission: [Permission.COMMON_EDIT],
				});
			}

			if (onDelete) {
				actions.push({
					name: i18n.t('Common.Delete'),
					onClick: () => {
						onDelete(r)
					},
					permission: [Permission.COMMON_EDIT],
					danger: true
				});
			}

			return <Buttons
				noMargin={true}
				moreButtons={actions}
			/>
		}
	}
];